<script setup lang="ts">
import { useCommonStore } from '@/stores/modules/common'
import { socketEmitAsync } from '@/utils/web-socket'
import { Lock, Message } from '@element-plus/icons-vue'
import type { FormInstance, FormRules } from 'element-plus'
import { md5 } from 'js-md5'
import { reactive, ref } from 'vue'

const commonStore = useCommonStore()

const emits = defineEmits(['success'])

const formRef = ref<FormInstance>()
const form = reactive({
  email: '',
  password: '',
  checkPassword: '',
})
const formRules: FormRules = {
  email: [
    { required: true, message: '请输入' },
    {
      pattern:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: '请输入正确的邮箱',
      trigger: 'blur',
    },
  ],
  password: [
    { required: true, message: '请输入' },
    { min: 6, max: 32, message: '长度在6~32', trigger: 'blur' },
  ],
  checkPassword: [
    { required: true, message: '请输入' },
    {
      validator: (_, value, callback) => {
        if (value !== form.password) {
          callback(new Error('与密码不一致'))
        }
        callback()
      },
      trigger: 'change',
    },
  ],
}

async function handleSubmit() {
  formRef.value?.validate(async (valid) => {
    if (!valid) return
    const { email, password } = form
    await socketEmitAsync<string>({ type: 'changePassword', data: { email, password: md5(password) } })
    localStorage.removeItem(import.meta.env.VITE_TOKEN_NAME)
    ElMessageBox.alert('密码修改成功，请重新登陆游戏', '温馨提示', {
      beforeClose: () => {
        location.reload()
      },
    })
    emits('success')
  })
}
</script>

<template>
  <div class="bind-email">
    <el-form ref="formRef" :model="form" :rules="formRules" v-loading="commonStore.loading">
      <el-form-item prop="email">
        <el-input v-model="form.email" :prefix-icon="Message" placeholder="请输入您绑定的邮箱"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="form.password" type="password" :prefix-icon="Lock" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item prop="checkPassword">
        <el-input v-model="form.checkPassword" type="password" :prefix-icon="Lock" placeholder="请确认密码"></el-input>
      </el-form-item>
      <el-form-item>
        <div style="width: 100%; text-align: center">
          <el-button type="primary" plain style="width: 80%; margin-bottom: 10px" @click="handleSubmit">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped></style>
